<div class="design-gallery-container">
  <div class="gallery-header">
    <h1>Design Elements Gallery</h1>
    <p class="subtitle">Click on any element to copy its code with classes</p>
  </div>

  <div class="controls">
    <div class="search-bar">
      <input
        type="text"
        placeholder="Search elements..."
        [(ngModel)]="searchTerm"
      />
    </div>

    <div class="category-filters">
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'all'"
        (click)="setCategory('all')"
      >
        All
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'button'"
        (click)="setCategory('button')"
      >
        Buttons
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'input'"
        (click)="setCategory('input')"
      >
        Inputs
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'form-field'"
        (click)="setCategory('form-field')"
      >
        Form Fields
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'badge'"
        (click)="setCategory('badge')"
      >
        Badges
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'step-indicator'"
        (click)="setCategory('step-indicator')"
      >
        Step Indicators
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'pipeline'"
        (click)="setCategory('pipeline')"
      >
        Pipeline
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'toggle'"
        (click)="setCategory('toggle')"
      >
        Toggles
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'slider'"
        (click)="setCategory('slider')"
      >
        Sliders
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'dialog'"
        (click)="setCategory('dialog')"
      >
        Dialogs
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'view-toggle'"
        (click)="setCategory('view-toggle')"
      >
        View Toggle
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'tooltip'"
        (click)="setCategory('tooltip')"
      >
        Tooltips
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'modal-header'"
        (click)="setCategory('modal-header')"
      >
        Modal Header
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'filter-pills'"
        (click)="setCategory('filter-pills')"
      >
        Filter Pills
      </button>
      <button
        class="filter-btn"
        [class.active]="selectedCategory === 'inline-job-loading'"
        (click)="setCategory('inline-job-loading')"
      >
        Inline loading
      </button>
    </div>
  </div>

  <div class="elements-gallery">
    @for (element of filteredElements; track element.name) {
      <div class="element-item" role="button" (click)="copyElement(element)">
        <div class="element-preview">
          @if (element.category === "button") {
            <button
              [class]="getButtonClasses(element.code)"
              [disabled]="element.name.includes('Disabled')"
            >
              @if (element.name.includes("Icon")) {
                <app-icon name="plus" [size]="16"></app-icon>
              } @else {
                {{ element.preview }}
              }
            </button>
          } @else if (element.category === "form-field") {
            <div class="form-field-preview">
              @if (element.componentType === "text-input") {
                <app-text-input
                  [label]="element.componentData?.label || 'field'"
                  [placeholder]="
                    element.componentData?.placeholder || 'Enter...'
                  "
                  [type]="element.componentData?.type || 'text'"
                  [control]="getFormControlForElement(element)"
                  [isFormSubmitted]="false"
                  [min]="element.componentData?.min || ''"
                  [class]="element.componentData?.class || ''"
                ></app-text-input>
              } @else if (element.componentType === "select-input") {
                <app-select-input
                  [label]="element.componentData?.label || 'option'"
                  [placeholder]="
                    element.componentData?.placeholder || 'Select...'
                  "
                  [control]="getFormControlForElement(element)"
                  [isFormSubmitted]="false"
                  [items]="selectOptions"
                  valueKey="id"
                  labelKey="name"
                  [allowClear]="
                    element.componentData?.allowClear !== undefined
                      ? element.componentData.allowClear
                      : false
                  "
                  [showSearch]="element.componentData?.showSearch || false"
                  class="common-dark-dropdown w-100"
                ></app-select-input>
              } @else if (element.componentType === "text-area") {
                <app-text-area
                  [label]="element.componentData?.label || 'description'"
                  [placeholder]="
                    element.componentData?.placeholder || 'Enter...'
                  "
                  [control]="getFormControlForElement(element)"
                  [isFormSubmitted]="false"
                  [rowsCount]="element.componentData?.rowsCount || 4"
                  [class]="element.componentData?.class || ''"
                ></app-text-area>
              } @else if (element.componentType === "date-picker") {
                <app-date-picker
                  [label]="element.componentData?.label || 'date'"
                  [control]="getFormControlForElement(element)"
                  [isFormSubmitted]="false"
                  [class]="element.componentData?.class || ''"
                ></app-date-picker>
              } @else if (element.componentType === "country-code-text-input") {
                <app-country-code-text-input
                  [label]="element.componentData?.label || 'phone number'"
                  [placeholder]="
                    element.componentData?.placeholder || 'Enter phone number'
                  "
                  [control]="getFormControlForElement(element)"
                  [isFormSubmitted]="false"
                  [countryCode]="element.componentData?.countryCode || '+91'"
                  [class]="element.componentData?.class || ''"
                ></app-country-code-text-input>
              } @else if (element.componentType === "sort-dropdown") {
                <div
                  class="sort-dropdown"
                  nz-dropdown
                  nzTrigger="click"
                  [nzDropdownMenu]="sortMenu"
                  [nzOverlayClassName]="'sort-dropdown-menu'"
                  (click)="$event.stopPropagation()"
                >
                  <span class="sort-label">Sort:</span>
                  <span class="sort-value">{{ selectedSort?.label }}</span>
                  <nz-dropdown-menu #sortMenu="nzDropdownMenu">
                    <ul nz-menu>
                      @for (item of sortOptions; track item.value) {
                        <li
                          [class.active]="selectedSort?.value == item?.value"
                          nz-menu-item
                          (click)="
                            selectedSort = item; $event.stopPropagation()
                          "
                        >
                          {{ item?.label }}
                        </li>
                      }
                    </ul>
                  </nz-dropdown-menu>
                </div>
              }
            </div>
          } @else if (element.category === "badge") {
            <span [class]="getBadgeClasses(element.code)">{{
              element.preview
            }}</span>
          } @else if (element.category === "step-indicator") {
            <div
              class="step-indicator-preview"
              [innerHTML]="element.htmlContent || element.code"
            ></div>
          } @else if (element.category === "pipeline") {
            <div
              class="pipeline-preview"
              [innerHTML]="element.htmlContent || element.code"
            ></div>
          } @else if (element.category === "toggle") {
            @if (element.name === "Compact Checkbox") {
              <label class="compact-checkbox-preview">
                <input type="checkbox" class="checkbox-compact" checked />
                <span>Checkbox</span>
              </label>
            } @else {
              <div
                class="toggle-preview"
                [innerHTML]="element.htmlContent || element.code"
              ></div>
            }
          } @else if (element.category === "slider") {
            <div
              class="slider-preview"
              [innerHTML]="element.htmlContent || element.code"
            ></div>
          } @else if (element.category === "view-toggle") {
            <div
              class="view-toggle-preview"
              [innerHTML]="element.htmlContent || element.code"
            ></div>
          } @else if (
            element.category === "filter-pills" ||
            element.componentType === "filter-pills"
          ) {
            <div
              class="filter-pills-preview"
              [innerHTML]="element.htmlContent || element.code"
            ></div>
          } @else if (element.category === "modal-header") {
            <div class="modal-header-preview">
              <div class="modal-header-left">
                <div class="modal-header-icon">
                  <app-icon name="star" [size]="16"></app-icon>
                </div>
                <div class="modal-header-text">
                  <h2 class="modal-header-title">Setup Campaign Soul</h2>
                  <span class="modal-header-sub">
                    Define the strategic DNA of your campaign
                  </span>
                </div>
              </div>
            </div>
          } @else if (element.category === "inline-job-loading") {
            <div class="inline-job-loading-preview">
              @if (element.name.includes("indeterminate")) {
                <app-inline-job-loading
                  iconName="file-text-docx"
                  [iconSize]="28"
                  title="dAIrector is processing your script"
                  subtitle="Formatting and structuring your upload…"
                  progressMode="indeterminate"
                />
              } @else {
                <app-inline-job-loading
                  iconName="file-text-docx"
                  [iconSize]="28"
                  title="dAIrector is writing your script"
                  subtitle="Submitting your request, then processing the job…"
                  progressMode="steps"
                  [progressPercent]="inlineJobDemoProgress"
                  [steps]="inlineJobDemoSteps"
                />
              }
            </div>
          } @else if (element.category === "tooltip") {
            <div class="tooltip-preview">
              @if (element.name === "Info Icon with Tooltip") {
                <span
                  class="info-icon"
                  nz-tooltip="Hover to see tooltip — dark bg, cyan border"
                >
                  <app-icon name="info-i" [size]="20"></app-icon>
                </span>
              } @else if (element.name === "Metric Label with Info Icon") {
                <div class="metric-label">
                  Total Campaigns
                  <span
                    class="info-icon"
                    nz-tooltip="Number of active campaign umbrellas"
                  >
                    <app-icon name="info-i" [size]="20"></app-icon>
                  </span>
                </div>
              }
            </div>
          } @else if (element.componentType === "textarea") {
            <textarea
              class="custom-instructions form-textarea"
              [formControl]="getFormControlForElement(element)"
              [placeholder]="
                element.componentData?.placeholder ||
                'Add any additional style notes or creative direction...'
              "
            ></textarea>
          } @else if (element.componentType === "search-input-wrapper") {
            <div class="search-input-wrapper">
              <app-icon
                name="search"
                [size]="18"
                color="color: var(--interface-dim);"
              ></app-icon>
              <input
                type="text"
                class="search-input"
                [placeholder]="
                  element.componentData?.placeholder || 'Search...'
                "
                readonly
              />
            </div>
          } @else if (element.componentType === "nz-select") {
            <nz-select
              [nzPlaceHolder]="
                element.componentData?.placeholder || 'Select Option'
              "
              [nzDropdownClassName]="'common-dropdown-menu'"
              [class]="'common-dark-dropdown w-100'"
              [ngModel]="selectedTabFilter"
              (ngModelChange)="getCampaignsList()"
            >
              @for (
                option of element.componentData?.options || [];
                track option.value
              ) {
                <nz-option
                  [nzValue]="option.value"
                  [nzLabel]="option.label"
                ></nz-option>
              }
            </nz-select>
          } @else if (element.category === "dialog") {
            <div class="dialog-preview">
              <div class="dialog-preview-content">
                <app-icon
                  name="info"
                  [size]="24"
                  color="color: var(--electric-cyan);"
                ></app-icon>
                <span>{{ element.preview }}</span>
              </div>
            </div>
          } @else {
            <input
              [type]="getInputType(element.code)"
              [class]="getInputClasses(element.code)"
              [placeholder]="element.preview"
              [disabled]="element.name.includes('Disabled')"
              readonly
            />
          }
        </div>
        <div class="element-info">
          <div class="element-name">{{ element.name }}</div>
          <div class="element-code">{{ element.code }}</div>
        </div>
      </div>
    }

    @if (filteredElements.length === 0) {
      <div class="no-results">No elements found matching your search.</div>
    }
  </div>
</div>
